import { render, staticRenderFns } from "./AlignBottomLeft.vue?vue&type=template&id=aa3b013a&scoped=true&"
import script from "./AlignBottomLeft.vue?vue&type=script&lang=js&"
export * from "./AlignBottomLeft.vue?vue&type=script&lang=js&"
import style0 from "./AlignBottomLeft.vue?vue&type=style&index=0&id=aa3b013a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3b013a",
  null
  
)

export default component.exports